// @flow

import React from 'react';
import { Label, OptionsWrapper, Wrapper } from './atoms';
import Radio from '../radio';
import Error from '../error';
import type { Props } from './types';

export default ({
  input,
  meta: {
    error,
    touched,
  },
  options,
}: Props) => (
  <Wrapper>
    <OptionsWrapper
      error={error}
      touched={touched}
    >
      {options.map(option => (
        <Label
          key={option.value}
          htmlFor={option.value}
        >
          <Radio
            id={option.value}
            type="radio"
            {...input}
            value={option.value}
            checked={option.value === input.value}
            error={false}
          />
          {option.label}
        </Label>
      ))}
    </OptionsWrapper>
    <>
      {touched && error
        && <Error message={error} />}
    </>
  </Wrapper>
);
